// Place items that already have a position, then drop unpositioned items
// into the unused integer slots (1, 2, 3, …). Duplicate positions overflow
// into the same filler queue so they don't stack on one slot.
export function orderByPosition(items, getPosition = (item) => item.position) {
  const placed = [];
  const unplaced = [];

  items.forEach((item, index) => {
    const raw = getPosition(item);
    if (raw === null || raw === undefined || raw === '') {
      unplaced.push(item);
      return;
    }

    const pos = Number(raw);
    if (Number.isFinite(pos)) placed.push({ item, pos, index });
    else unplaced.push(item);
  });

  placed.sort((a, b) => a.pos - b.pos || a.index - b.index);

  const bySlot = new Map();
  const extras = [];
  for (const entry of placed) {
    if (!bySlot.has(entry.pos)) bySlot.set(entry.pos, entry.item);
    else extras.push(entry.item);
  }

  const fillers = [...extras, ...unplaced];
  let nextFiller = 0;

  const minSlot = placed.length ? Math.min(1, ...placed.map((e) => e.pos)) : 1;
  const maxSlot = Math.max(items.length, ...placed.map((e) => e.pos), 0);

  const ordered = [];
  for (let slot = minSlot; slot <= maxSlot; slot++) {
    if (bySlot.has(slot)) ordered.push(bySlot.get(slot));
    else if (nextFiller < fillers.length) ordered.push(fillers[nextFiller++]);
  }

  while (nextFiller < fillers.length) ordered.push(fillers[nextFiller++]);

  return ordered;
}

// Systems in the order the sidebar shows them: by position, with each group
// kept together where its first system falls. Returns [[group, items], …].
export function groupByPosition(items, getPosition = (item) => item.position, getGroup = (item) => item.group) {
  const groups = new Map();
  for (const item of orderByPosition(items, getPosition)) {
    const group = getGroup(item);
    if (!groups.has(group)) groups.set(group, []);
    groups.get(group).push(item);
  }
  return [...groups];
}
